<template>
  <v-container class="ma-0 pa-0" style="width: 100vw" fluid>
    <v-row class="d-flex align-center justify-center pa-5 pb-12 ma-0" style="width: 100% !important; background-color: #111111">
      <div>
        <v-img class="justify-center my-5 mx-0" src="https://swiset.com/wp-content/uploads/2020/09/Swiset_Imagotipo_Full_RGB_White.svg" max-height="21px" contain/>
        <h1 style="color:#ffffff;" class="text-center">{{ getMasterTitle() }}</h1>
        <p style="color: #ffffff" class="text-center">{{ getMasterText() }}</p>
      </div>
    </v-row>
    <v-row align="center" justify="center" class="justify-center mt-n7 mx-0" style="width: 100%;">
      <v-col cols="12" sm="12" md="12" lg="4" xl="4">
        <iframe @click="facebookTrigger" style="border: 2px #00F784 solid; border-radius: 2%" width="100%" :height="(this.$store.state.desktop)? 350 : 228"
                src="https://www.youtube.com/embed/PX4bhjjItwk"
                frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
      </v-col>
    </v-row>
    <v-row class="d-flex align-center justify-center pa-5 ma-0" style="width: 100% !important; background-color: #FFF75F">
      <div>
        <v-btn style="color: #3a3a3a" class="swiset-button text-center" @click="scrollToRegister">{{ getCTAButtonText() }}</v-btn>
      </div>
    </v-row>
    <v-row class="justify-center pa-5 mx-0 my-5" style="width: 100%;">
      <v-col cols="12" sm="12" md="12" lg="3" xl="3">
        <v-icon color="#00a553" class="d-flex justify-center mb-2" large>fa-trophy</v-icon>
        <h3 class="text-center" style="color: #00a553">{{ getAwardsTitle() }}</h3>
        <v-list style="background-color: rgba(0,0,0,0)">
          <v-list-item class="d-flex mt-n1" v-bind:key="award.number" v-for="award in awards">
            <h2 style="color: #00a553" :class="`mr-3 ml-${ (award.number === 1)? 0 : (award.number === 2)? 5 : 10}`"
                small>{{ award.number }}{{ award.suffix }}</h2>
            <h3 style="color: #111111" class="d-flex justify-start text-start">{{ award.text }}</h3>
          </v-list-item>
        </v-list>
        <p class="text-center mt-3">{{ getSponsorText() }}</p>
        <v-img class="justify-center my-3 mx-0" src="https://d33wubrfki0l68.cloudfront.net/23081b338c89f581dcbd06f4e555c9edec72aa0a/938da/assets/img/logo.svg" max-height="30px" contain/>
        <!--v-img class="justify-center my-3 mx-0" src="https://swiset.com/wp-content/uploads/2020/08/Earn2Trade-plus-Swiset.png" max-height="30px" contain/!-->
        <v-divider v-if="!this.$store.state.desktop" class="my-5"/>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="3" xl="3">
        <h3 class="text-center" style="color: #111111">{{ getParticipantsTitle() }}</h3>
        <!--p class="text-center mt-5">{{ getParticipantsText() }}</p!-->
        <v-list style="background-color: rgba(0,0,0,0)">
          <v-list-item class="d-flex mt-n1" v-bind:key="who.number" v-for="who in whoCan">
            <h4 color="black" class="mr-3">{{ who.number }}</h4>
            <p class="d-flex justify-center text-start">{{ who.text }}</p>
          </v-list-item>
        </v-list>
        <v-list style="background-color: rgba(0,0,0,0)" class="mt-5">
          <v-list-item class="d-flex mt-n1" v-bind:key="reason.number" v-for="reason in reasons">
            <h4 style="width: 100%; color: #00a553;" class="text-center">{{ reason.text }}</h4>
          </v-list-item>
        </v-list>
        <v-divider v-if="!this.$store.state.desktop" class="my-5"/>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="3" xl="3">
        <h3 class="text-center" style="color: #111111">{{ getRulesTitle() }}</h3>
        <v-list style="background-color: rgba(0,0,0,0)">
          <v-list-item class="d-flex mt-n1" v-bind:key="rule.number" v-for="rule in rules">
            <h4 color="black" class="mr-3">{{ rule.number }}</h4>
            <p class="d-flex justify-center text-start mb-n2">{{ rule.text }}</p>
          </v-list-item>
        </v-list>
        <p class="text-center mt-5">{{ getRulesFinalText() }}</p>
        <iframe @click="facebookTrigger" style="border: 2px #00F784 solid; border-radius: 2%" width="100%" :height="(this.$store.state.desktop)? 350 : 228"
                src="https://www.youtube.com/embed/WNg-kzMzD4c"
                frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
        <v-divider v-if="!this.$store.state.desktop" class="my-5"/>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="3" xl="3">
        <h3 class="text-center" style="color: #111111">{{ getStepsTitle() }}</h3>
        <v-list style="background-color: rgb(0,0,0,0)">
          <v-list-item class="d-flex mt-n1" v-bind:key="verification.number" v-for="verification in verifications">
            <h4 color="black" class="mr-3">{{ verification.number }}</h4>
            <p class="d-flex justify-center text-start mb-n2">{{ verification.text }}</p>
          </v-list-item>
        </v-list>
        <!--p class="d-flex justify-center mt-2">{{ getStepsText() }}</p!-->
        <!--v-list style="background-color: rgb(0,0,0,0)">
          <v-list-item class="d-flex mt-n1" v-bind:key="step.icon" v-for="step in steps">
            <v-icon color="black" class="mr-3" small>{{ step.icon }}</v-icon>
            <p class="d-flex justify-center text-start mb-n2">{{ step.text }}</p>
          </v-list-item>
        </v-list!-->
      </v-col>
    </v-row>
    <v-row class="d-flex align-center justify-center pa-5 ma-0" style="width: 100% !important; background-color: #FFF75F">
      <div>
        <v-btn style="color: #3a3a3a" class="swiset-button text-center" @click="scrollToRegister">{{ getCTAButtonText() }}</v-btn>
      </div>
    </v-row>
    <v-row class="d-flex align-center justify-center py-10 px-7 ma-0" style="background-color: #111111; width: 100%">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <v-icon color="#00F784" class="d-flex justify-center" large>fa-users</v-icon>
        <h3 style="color:#FFFFFF;" class="text-center my-3 px-12">{{ getSocialProofTitle() }}</h3>
        <div class="d-flex align-center justify-center"><p style="color: #F8F8F8" class="text-center mb-7">{{ getSocialProofText() }}</p>
          <a href="https://swiset.com/es/home-espanol" target="_blank"><p style="color: #00F784" class="ml-1 mb-7">{{ getSwisetLinkText() }}</p></a></div>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="4" xl="4">
        <iframe @click="facebookTrigger" style="border: 2px #00F784 solid; border-radius: 2%" width="100%" :height="(this.$store.state.desktop)? 350 : 228"
                src="https://www.youtube.com/embed/0wtu0CzmRJc"
                frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="4" xl="4">
        <iframe @click="facebookTrigger" style="border: 2px #00F784 solid; border-radius: 2%" width="100%" :height="(this.$store.state.desktop)? 350 : 228"
                src="https://www.youtube.com/embed/hF3ZaSIFcpo"
                frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="12" md="12" lg="4" xl="4">
        <CollapsedRegister id="register" :language="language" :campaign="'B'"/>
      </v-col>
    </v-row>
    <v-img class="justify-center mt-5 mb-7" src="https://swiset.com/wp-content/uploads/2020/05/Swiset_Imagotipo_RGB_Black.svg" max-height="17px" contain/>
  </v-container>
</template>

<script>
import CollapsedRegister from "@/components/CollapsedRegister";
import { mapMutations } from 'vuex';
export default {
  name: "FundingCampaignC",
  components: {CollapsedRegister},
  data() {
    return {
      language: String,
      whoCan: [],
      reasons: [],
      steps: [],
      rules: [],
      awards: [],
      verifications: [],

      // Parametrization
      masterTitle: '',
      masterText: '',
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapMutations(['setDesktopContext']),
    init() {
      let desktop = screen.width >= 760;
      this.setDesktopContext(desktop);

      let lang = this.$route.query.lang;
      if (lang !== undefined)
        this.language = lang;
      else
        this.language = 'ES';

      this.setWhoCanParticipate();
      this.setReasons();
      this.setSteps();
      this.setAwards();
      this.setRules()
      this.setResultsVerification();

      window.fbq('track', 'Lead');
    },
    scrollToRegister() {
      let element = document.querySelector("#register");
      element.scrollIntoView({ behavior: 'smooth', block: 'end'});
    },

    // Parametrization
    getMasterTitle() {
      return (this.language === 'EN')? 'Futures Tournament!' : '¡Torneo de Futuros!';
    },
    getMasterText() {
      return (this.language === 'EN')? 'Yes. Funding examination for free with Swiset Pro.' : 'Reserva tu lugar para el torneo de futuros.';
    },
    getAwardsTitle() {
      return (this.language === 'EN')? 'Win one of the tournament rewards:' : 'Premios';
    },
    getParticipantsTitle() {
      return (this.language === 'EN')? 'Who can participate?' : '¿Quienes pueden participar?';
    },
    getParticipantsText() {
      return (this.language === 'EN')? '' : 'El torneo es completamente gratuito para usuarios Swiset pro. Sin embargo, si no lo eres, puedes pagar 5usd y participar del torneo y además de eso obtendrás la membresía Pro que te permitirá hacer un análisis completo de tus resultados durante todo el mes de octubre.';
    },
    getSponsorText() {
      return (this.language === 'EN')? 'Funding exam by:' : 'Pruebas de fondeo de:';
    },
    getStepsTitle() {
      return (this.language === 'EN')? 'Steps to participate:' : 'Verificación de resultados:';
    },
    getRulesTitle() {
      return (this.language === 'EN')? 'Tournament rules:' : 'Reglas del torneo y tabla de ganadores';
    },
    getRulesFinalText() {
      return (this.language === 'EN')? '' : 'Premiamos tu consistencia no la suerte apra que te conviertas en un mejor trader.';
    },
    getStepsText() {
      return (this.language === 'EN')? '' : 'Una vez te registres, dentro de la aplicación web en la pestaña de “tournament” encontrarás los pasos para automatizar tu cuenta de Ninja trader. Posteriormente verificar esta cuenta (y así Swiset llevaría el registro automático de todas tus operaciones sin la posibilidad de editar, eliminar o adicionar información en los resultados de esa cuenta). Esto da la posibilidad de auditar tus resultados y que sean 100% confiables para la tabla de ganadores del torneo. ';
    },
    getSecondText() {
      return (this.language === 'EN')? '3 simple steps to compete on our tournament:' : 'En 3 simples pasos podrás acceder a nuestro torneo:';
    },
    getCTATitle() {
      return (this.language === 'EN')? 'Join the tournament now' : 'Únete ahora al torneo';
    },
    getCTAButtonText() {
      return (this.language === 'EN')? 'Join the tournament now' : 'Únete ahora al torneo';
    },
    getSocialProofTitle() {
      return (this.language === 'EN')? 'Trusted by traders and academies in +28 countries' : 'Regístrate al torneo y ten un mes gratis de Swiset Pro';
    },
    getSocialProofText() {
      return (this.language === 'EN')? 'Listen our community reviews' : 'Plataforma líder en gestión de riesgos. Escucha opiniones.';
    },
    getSwisetLinkText() {
      return (this.language === 'EN')? 'What is Swiset?' : '¿Qué es Swiset?';
    },
    setWhoCanParticipate() {
      let whoCanEN = [
        { number: 1, text: 'Be Swiset Pro user' },
        { number: 2, text: 'Be Swiset Pro user' },
      ];
      let whoCanES = [
        { number: 1, text: 'Usuarios actuales de Swiset Pro (gratis).' },
        { number: 2, text: 'Si no tienes cuenta, paga 5 USD y participa en el torneo. Tendrás una cuenta Pro temporal para verificar tus resultados y mejorar tu consistencia.' },
      ];
      this.whoCan = (this.language === 'EN')? whoCanEN : whoCanES;
    },
    setReasons() {
      let reasonsEN = [
        { number: 1, text: 'Be Swiset Pro user' },
        { number: 2, text: 'Be Swiset Pro user' },
      ];
      let reasonsES = [
        { number: 1, text: 'Transparente, sin trampas.' },
        { number: 1, text: 'Consulta de resultados de forma constante y en vivo.' },
        { number: 1, text: 'Te convertimos en un trader más consistente.' },
      ];
      this.reasons = (this.language === 'EN')? reasonsEN : reasonsES;
    },
    setAwards() {
      let awardsEN = [
        { number: 1, suffix: 'st', text: '75K USD Funding Exam' },
        { number: 2, suffix: 'nd', text: '50K USD Funding Exam' },
        { number: 3, suffix: 'rd', text: '25K USD Funding Exam' },
      ];
      let awardsES = [
        { number: 1, suffix: 'ro', text: 'Prueba de Fondeo 75K USD' },
        { number: 2, suffix: 'do', text: 'Prueba de Fondeo 50K USD' },
        { number: 3, suffix: 'ro', text: 'Prueba de Fondeo 25K USD' },
      ];
      this.awards = (this.language === 'EN')? awardsEN : awardsES;
    },
    setSteps() {
      let stepsEN = [
        { icon: 'fa-star', text: 'Be Swiset Pro user' },
        { icon: 'fa-check', text: 'Verify an account on Swiset' },
        { icon: 'fa-dollar-sign', text: 'Compete and get 1 of the 3 FREE funding examination' },
      ];
      let stepsES = [
        { icon: 'fa-star', text: 'Integrar tus cuentas de NinjaTrader' },
        { icon: 'fa-check', text: 'Verifica una de tus cuentas en Swiset' },
        { icon: 'fa-dollar-sign', text: 'Compite y obten 1 de nuestras 3 pruebas de fondeo.' },
      ];
      this.steps = (this.language === 'EN')? stepsEN : stepsES;
    },
    setRules() {
      let rulesEN = [
        { number: 1, text: 'Minimum 15 days of trading' },
        { number: 2, text: 'NinjaTrader 8 as plataform' },
        //{ number: 3, text: 'Any time is valid' },
        //{ number: 4, text: 'Folow @getswiset and @earn2trade_esp on IG' },
        { number: 3, text: 'Most winning trade cannot be greater than 30% total' },
      ];
      let rulesES = [
        { number: '+', text: 'Fecha de registro domingo 4 Octubre 11pm' },
        { number: '+', text: 'Fecha de inicio  Lunes 5 Octubre' },
        { number: '+', text: 'Fecha de finalización Viernes 30 Octubre' },
        { number: '+', text: 'Anuncio premios Lunes 2 Noviembre' },
        //{ number: 3, text: 'Cualquier horario es válido' },
        //{ number: 4, text: 'Seguir a @getswiset y @earn2trade_esp en IG' },
      ];
      this.rules = (this.language === 'EN')? rulesEN : rulesES;
    },
    setResultsVerification() {
      let verificationsEN = [
        { number: '+', text: 'Regístrate en Swiset – Tendrás una cuenta pro por este mes.' },
        { number: '+', text: 'Enlaza tu cuenta de Ninja Trader.' },
        { number: '+', text: 'Así garantizamos datos 100% confiables en tiempo.' },
        { number: '+', text: 'Podrás tener visibilidad de los resultados en cada operación.' },
      ];
      let verificationsES = [
        { number: '+', text: 'Regístrate en Swiset – Tendrás una cuenta pro por este mes.' },
        { number: '+', text: 'Enlaza tu cuenta de Ninja Trader.' },
        { number: '+', text: 'Así garantizamos datos 100% confiables en tiempo.' },
        { number: '+', text: 'Podrás tener visibilidad de los resultados en cada operación.' },
      ];
      this.verifications = (this.language === 'EN')? verificationsEN : verificationsES;
    },
    facebookTrigger() {
      window.fbq('track', 'ViewContent');
    },
  }
}
</script>

<style scoped>

</style>
